import React, { useState, useEffect } from "react";
import axios from "axios";
import routes from "../../../app/routes";

export default function TableItemActions({
  row,
  teamId,
  updateCollection,
  editData,
  showMembers,
}) {
  const editCycle = (id) => {
    axios
      .get(routes.api.cycles.edit(id), {
        params: { enterprise_team_id: teamId },
      })
      .then((data) => {
        editData(data.data.data);
      });
  };
  const deleteCycle = (id) => {
    swal(
      {
        title: "Delete Cycle",
        text: "Do you really want to delete cycle?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      function (isConfirm) {
        if (isConfirm) {
          axios
            .delete(routes.api.cycles.destroy(id), {
              params: { enterprise_team_id: teamId },
            })
            .then(() => updateCollection());
        }
      }
    );
  };

  return (
    <>
      <a
        onClick={() => editCycle(row.id)}
        className="btn btn-primary"
        title="Edit cycle"
        data-toggle="tooltip"
      >
        <i className="fa fa-fw fa-edit"></i>
      </a>
      <a
        onClick={() => showMembers(row)}
        className="btn btn-primary btn-outline ml5"
        title="Show Members"
        data-toggle="tooltip"
      >
        <i className="fa fa-fw fa-users"></i>
      </a>
      <a
        onClick={() => deleteCycle(row.id)}
        className="btn btn-danger ml5"
        title="Delete Cycle"
        data-toggle="tooltip"
      >
        <i className="fa fa-fw fa-trash"></i>
      </a>
    </>
  );
}
